// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__21U4A","selected":"Chip_selected__3pisq"};